import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";

/**
 * Sets the document `<title>`/favicon/theme-color from tenant settings —
 * infrastructure, not a visual page, so it moved here rather than into any
 * `features/*` page. Behavior unchanged from the legacy
 * `components/Helmet`.
 */
export const HelmetContainer = () => {
  const customerWebText = useSelector((state: RootState) => state.setting.customerWebText);
  const favIconUrl = useSelector((state: RootState) => state.setting.favIconUrl);
  const primaryColor = useSelector((state: RootState) => state.setting.colors.primary);
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <Helmet>
      <title>{customerWebText.title}</title>
      <meta name={customerWebText.title} content={t("TrackPage", language)} />
      <link rel="icon" type="image/png" href={favIconUrl} sizes="16x16" />
      <meta name="theme-color" content={primaryColor} />
    </Helmet>
  );
};
